module.exports = __webpack_public_path__ + "static/media/1f389.7279b3c3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/emoji/1f389.svg
// module id = 622
// module chunks = 1